module.exports = __webpack_public_path__ + "img/menu-rx.7da6eb40.png";